// Modern theme configuration
export const breakpoints = {
  mobile: '600px',
  tablet: '900px',
  desktop: '901px',
};

export const theme = {
  colors: {
    // Base colors
    primary: "#8B5CF6", // Vibrant Purple
    primaryLight: "#A78BFA",
    primaryDark: "#6D28D9",
    accent: "#EC4899", // Vibrant Pink
    accentLight: "#F472B6",
    accentDark: "#DB2777",

    // Text colors
    text: "#F8FAFC", // Slate 50 (Light text for dark mode)
    textDark: "#E2E8F0", // Slate 200
    textMuted: "#94A3B8", // Slate 400

    // Background colors
    background: "#0F172A", // Slate 900 (Dark background)
    backgroundDark: "#020617", // Slate 950
    cardBackgroundDark: "rgba(15, 23, 42, 0.9)", // Slate 900 with opacity
    buttonBackground: "rgba(139, 92, 246, 0.1)", // Primary with low opacity
    buttonBackgroundHover: "rgba(139, 92, 246, 0.2)",
    inputBackground: "rgba(30, 41, 59, 0.6)",
    inputBackgroundDark: "rgba(15, 23, 42, 0.8)",

    // Border colors
    border: "#1E293B", // Slate 800
    borderDark: "#0F172A", // Slate 900
    borderPrimary: "rgba(139, 92, 246, 0.3)", // Primary with opacity
    borderPrimaryDark: "rgba(109, 40, 217, 0.4)", // Primary dark with opacity

    // UI element colors
    sliderBackground: "rgba(139, 92, 246, 0.2)",
    sliderBackgroundDark: "rgba(109, 40, 217, 0.2)",
  },

  gradients: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
    backgroundDark: "linear-gradient(135deg, #020617 0%, #0F172A 100%)",
    title: "linear-gradient(to right, #8B5CF6, #EC4899)",
    button: "linear-gradient(to right, #8B5CF6, #EC4899)",
    buttonHover: "linear-gradient(to right, #6D28D9, #DB2777)",
    card: "linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.8) 100%)",
    glow: "radial-gradient(circle at center, rgba(139, 92, 246, 0.15) 0%, rgba(139, 92, 246, 0) 70%)",
  },

  borderRadius: {
    sm: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    full: "9999px",
  },

  shadows: {
    sm: "0 1px 2px rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },
  typography: {
    fontFamily: `'Geist Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif`,
    fontSize: {
      small: "14px",
      medium: "16px",
      large: "18px",
      xlarge: "24px",
    },
  },
  breakpoints,
};

export type Theme = typeof theme;
export type Breakpoints = typeof breakpoints;
export default theme;
